import React from 'react';

type TGenericPopUpContext = {
    isGenericPopUp: boolean;
};

export const GenericPopUpContext = React.createContext<TGenericPopUpContext>({isGenericPopUp: false});

